import * as z from 'zod'
import type {
  CollectionSale,
  MotiveSale,
  SalesCounters,
  SalesPage,
  TopicGroupSale,
  TopicSale,
} from '@/api/sales/types'

const salesCountersSchema = {
  sales7: z.number(),
  sales30: z.number(),
  sales60: z.number(),
  sales90: z.number(),
  sales365: z.number(),
  salesTotal: z.number(),
} satisfies { [K in keyof SalesCounters]: z.ZodType<SalesCounters[K]> }

export const collectionSaleSchema: z.ZodType<CollectionSale> = z.object({
  collectionId: z.number(),
  collectionName: z.string().nullable(),
  ...salesCountersSchema,
})

export const motiveSaleSchema: z.ZodType<MotiveSale> = z.object({
  motiveKey: z.string(),
  motiveName: z.string().nullable(),
  collectionId: z.number().nullable(),
  collectionName: z.string().nullable(),
  ...salesCountersSchema,
})

export const topicGroupSaleSchema: z.ZodType<TopicGroupSale> = z.object({
  topicGroupId: z.number(),
  topicGroupName: z.string().nullable(),
  ...salesCountersSchema,
})

export const topicSaleSchema: z.ZodType<TopicSale> = z.object({
  topicId: z.number(),
  topicName: z.string().nullable(),
  topicGroupId: z.number(),
  topicGroupName: z.string().nullable(),
  ...salesCountersSchema,
})

/** Baut das Gridify-Antwortschema `{ count, data }` für eine der vier Ebenen. */
export function salesPageSchema<T>(item: z.ZodType<T>): z.ZodType<SalesPage<T>> {
  return z.object({
    count: z.number(),
    data: z.array(item),
  })
}
